.root {
    --dot-width: var(--carousel-dot-width, 12px);
    --dots-gap: var(--carousel-dots-gap, 4px);
    --dot-color: var(--carousel-dot-color, black);
    --dot-active-color: var(--carousel-dot-active-color, gray);

    display: flex;
    justify-content: center;
    gap: var(--dots-gap);
}

.dot {
    width: var(--dot-width);
    height: var(--dot-width);
    border-radius: var(--dot-width);
}

.dotActive {
    composes: dot;
    background-color: var(--dot-active-color);
}

.dotInactive {
    composes: dot;
    background-color: var(--dot-color);
}
